var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { AppPropsContext } from "../../hooks/AppPropsContext";
import Button from '../../button';
export default function SchedulerCTA(_a) {
    var handleOnClick = _a.handleOnClick;
    var schedulerCTA = useContext(AppPropsContext).schedulerCTA;
    if (!schedulerCTA || !schedulerCTA.length) {
        return null;
    }
    return (_jsx("div", __assign({ className: "mp-capturesvc-button-container mp-capturesvc-scheduler-button-container" }, { children: schedulerCTA.map(function (cta) { return (_jsx(Button, __assign({ htmlId: cta.htmlId, dark: cta === null || cta === void 0 ? void 0 : cta.dark, onClick: (cta === null || cta === void 0 ? void 0 : cta.onClick) || handleOnClick, label: cta === null || cta === void 0 ? void 0 : cta.label, buttonType: cta === null || cta === void 0 ? void 0 : cta.buttonType }, cta), cta.htmlId)); }) })));
}
